export default __webpack_public_path__ + "static/media/icon-instagram.5d332c12.svg";